/**
 * fonioAnruf - Typen & reine Hilfsfunktionen fuer eingehende fonio-Anrufe.
 * Build-Marker: anruf-modal-v2
 *
 * Daten: Supabase-Tabelle public.eingehende_anrufe (Edge Functions fonio-inbound
 * + fonio-postcall). Keine React-/Supabase-Imports -> unit-testbar (Vitest).
 */

export type AnrufQuelle = 'crm_kontakt' | 'kunde' | 'unbekannt';
export type AnrufStatus = 'eingegangen' | 'gesehen' | 'erledigt';

export interface EingehenderAnruf {
  id: string;
  eingegangen_am: string;
  from_number: string | null;
  to_number: string | null;
  anrufer_name: string | null;
  anrufer_firma: string | null;
  quelle: AnrufQuelle;
  crm_kontakt_id: string | null;
  kunde_id: string | null;
  akte_id: string | null;
  akten_nummer: string | null;
  status: AnrufStatus | string;
  // Gespraechsdaten aus dem Post-Call-Webhook (optional, kommt nach Gespraechsende)
  zusammenfassung?: string | null;
  anliegen?: string | null;
  transkript?: string | null;
  termin_wunsch?: string | null;
  rueckruf_gewuenscht?: boolean | null;
  dauer_sekunden?: number | null;
  beendet_am?: string | null;
  raw?: unknown;
}

/** Anzeigename des Anrufers oder Fallback. */
export function callerDisplay(c: Pick<EingehenderAnruf, 'anrufer_name'>): string {
  const n = (c.anrufer_name || '').replace(/\s+/g, ' ').trim();
  return n || 'Unbekannter Anrufer';
}

/** Ist der Anrufer in CRM/Kunden bekannt? */
export function isBekannt(c: Pick<EingehenderAnruf, 'quelle'>): boolean {
  return c.quelle === 'crm_kontakt' || c.quelle === 'kunde';
}

/** Anzahl der noch nicht gesehenen Anrufe (fuer das Badge). */
export function unreadCount(calls: Pick<EingehenderAnruf, 'status'>[]): number {
  return calls.filter((c) => c.status === 'eingegangen').length;
}

/** Telefonnummer huebsch gruppieren (deutsches Format, tolerant). */
export function formatGermanPhone(raw: string | null | undefined): string {
  if (!raw) return '';
  const s = raw.replace(/[^\d+]/g, '');
  if (!s) return raw.trim();
  if (s.startsWith('+49')) {
    const rest = s.slice(3);
    return ('+49 ' + rest.replace(/(\d{3})(?=\d)/, '$1 ')).trim();
  }
  if (s.startsWith('0')) {
    return (s.slice(0, 4) + ' ' + s.slice(4)).trim();
  }
  return s;
}

/** Relative Zeitangabe auf Deutsch. */
export function timeAgoDe(iso: string, now: number = Date.now()): string {
  const diffMin = Math.floor((now - new Date(iso).getTime()) / 60000);
  if (diffMin < 1) return 'Gerade eben';
  if (diffMin < 60) return `vor ${diffMin} Min`;
  if (diffMin < 1440) return `vor ${Math.floor(diffMin / 60)} Std`;
  return `vor ${Math.floor(diffMin / 1440)} Tagen`;
}
